(() => {
  const initializeLibrary = (scope = document) => {
    scope.querySelectorAll('[data-reverie-library-item]').forEach((item) => {
      const button = item.querySelector('.reverie-silk-library__summary');
      const panel = item.querySelector('.reverie-silk-library__answer');

      if (!button || !panel || button.dataset.reverieLibraryReady === 'true') return;

      button.dataset.reverieLibraryReady = 'true';
      panel.hidden = button.getAttribute('aria-expanded') !== 'true';
      button.addEventListener('click', () => {
        const isOpen = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!isOpen));
        item.toggleAttribute('data-open', !isOpen);
        panel.hidden = isOpen;
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeLibrary());
  } else {
    initializeLibrary();
  }

  document.addEventListener('shopify:section:load', (event) => initializeLibrary(event.target));
})();
